export default __webpack_public_path__ + "static/media/support-notes-main-cio.1ed3c1ce.png";